/**
 * Custom Products Block - Add to Cart Functionality
 * Handles AJAX add to cart for custom product cards
 */

if (!customElements.get('custom-products-block')) {
  class CustomProductsBlock extends HTMLElement {
    constructor() {
      super();
      this.addToCartButtons = this.querySelectorAll('.custom-product-card__add-to-cart');
      this.init();
    }

    init() {
      this.addToCartButtons.forEach((button) => {
        button.addEventListener('click', this.handleAddToCart.bind(this));
      });
    }

    async handleAddToCart(event) {
      event.preventDefault();
      
      const button = event.currentTarget;
      const variantId = button.dataset.variantId;
      
      if (!variantId) return;

      // Show loading state
      button.classList.add('loading');
      button.disabled = true;

      try {
        // Add item to cart via Shopify AJAX API
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId),
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }

        const data = await response.json();

        // Update cart drawer
        this.updateCartDrawer();

        // Open cart drawer
        this.openCartDrawer();

      } catch (error) {
        console.error('Error adding to cart:', error);
        // Show error message (optional)
        this.showError(button, 'Failed to add to cart. Please try again.');
      } finally {
        // Remove loading state
        button.classList.remove('loading');
        button.disabled = false;
      }
    }

    updateCartDrawer() {
      // Fetch cart drawer section to update it
      fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
        .then((response) => response.text())
        .then((responseText) => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newDrawerInner = html.querySelector('.drawer__inner');
            const currentDrawerInner = cartDrawer.querySelector('.drawer__inner');
            
            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }
          }
          
          // Update cart icon bubble
          fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const newBubble = html.querySelector('.shopify-section');
              const currentBubble = document.getElementById('cart-icon-bubble');
              
              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            });
        });
    }

    openCartDrawer() {
      // This theme uses cart-drawer custom element
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer && cartDrawer.open) {
        cartDrawer.open();
      }
    }

    showError(button, message) {
      // Remove any existing error message
      const existingError = button.parentElement.querySelector('.error-message');
      if (existingError) {
        existingError.remove();
      }

      // Create and show error message
      const errorElement = document.createElement('div');
      errorElement.className = 'error-message';
      errorElement.textContent = message;
      errorElement.style.cssText = `
        color: #d72c0d;
        font-size: 0.85rem;
        margin-top: 0.5rem;
      `;
      
      button.parentElement.appendChild(errorElement);

      // Remove error after 3 seconds
      setTimeout(() => {
        errorElement.remove();
      }, 3000);
    }
  }

  customElements.define('custom-products-block', CustomProductsBlock);
}
